import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    codigo: '',
    nombre: '',
    descripcion: '',
    rubroId: 0,
    rubro: null,
    rubroNombre: null,
    cotizacion: 0,
    pjeAmortizacion: 0,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_BIEN'(state, bienId) {
        state.id = bienId;
        state.codigo = '';
        state.nombre = '';
        state.descripcion = '';
        state.rubroId = 0;
        state.rubro = null;
        state.rubroNombre = null;
        state.cotizacion = 0;
        state.pjeAmortizacion = 0;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_BIEN'(state, bien) {
        state.codigo = bien.codigo.toUpperCase().trim();
        state.nombre = bien.nombre.toUpperCase().trim();
        state.descripcion = bien.descripcion.trim();
        state.rubroId = bien.rubroId;
        state.rubro = bien.rubro;
        state.rubroNombre = bien.rubro? bien.rubro.nombre.trim() : null;
        state.cotizacion = parseFloat(bien.cotizacion);
        state.pjeAmortizacion = parseFloat(bien.pjeAmortizacion);
        state.inactivo = (/true/i).test(bien.inactivo);
        state.rowVersion = bien.rowVersion;
    },
    'SET_RUBRO'(state, rubro) {
        state.rubro = rubro;
        if (rubro) {
            state.rubroId = rubro.id? rubro.id : 0;
            state.rubroNombre = rubro.nombre? rubro.nombre.trim() : null;
        } else {
            state.rubroId = 0;
            state.rubroNombre = null;
        }
    },
    'SET_BIEN_ID' (state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },
};

const getters = {
    getField,

    bien(state) {
        return {
            id: state.id,
            codigo: state.codigo.toUpperCase().trim(),
            nombre: state.nombre.toUpperCase().trim(),
            descripcion: state.descripcion.trim(),
            rubroId: state.rubroId,
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, bienId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BIEN', bienId);
            
            if (bienId != 0){
                apiAxios.get(`bienes/${bienId}/abm` ) 
                    .then(res => {
                        commit('SET_BIEN', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let bien= {
                codigo: state.codigo.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                rubroId: parseInt(state.rubroId),
                cotizacion: parseFloat(state.cotizacion),
                pjeAmortizacion: parseFloat(state.pjeAmortizacion),
                inactivo: (/true/i).test(state.inactivo),
            }
            let url = 'bienes';
            
            if (state.id != 0) {
                url += '/' + state.id;
                bien.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, bien)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_BIEN_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setRubro: ({commit}, rubro) => {
        commit('SET_RUBRO', rubro);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}